import { render } from "./SuppliersSubledger.vue?vue&type=template&id=2b37c386"
import script from "./SuppliersSubledger.vue?vue&type=script&lang=js"
export * from "./SuppliersSubledger.vue?vue&type=script&lang=js"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__